import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, makeEnvironmentProviders, NgZone, Injector } from '@angular/core';
import { ɵgetAllInstancesOf as _getAllInstancesOf, ɵgetDefaultInstanceOf as _getDefaultInstanceOf, VERSION, ɵAngularFireSchedulers as _AngularFireSchedulers, ɵzoneWrap as _zoneWrap } from '@angular/fire';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { AppCheckInstances } from '@angular/fire/app-check';
import { AuthInstances } from '@angular/fire/auth';
import { registerVersion } from 'firebase/app';
import { timer, from } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import { httpsCallable as httpsCallable$1 } from 'rxfire/functions';
import { connectFunctionsEmulator as connectFunctionsEmulator$1, getFunctions as getFunctions$1, httpsCallable as httpsCallable$2, httpsCallableFromURL as httpsCallableFromURL$1 } from 'firebase/functions';
export * from 'firebase/functions';
class Functions {
  constructor(functions) {
    return functions;
  }
}
const FUNCTIONS_PROVIDER_NAME = 'functions';
class FunctionsInstances {
  constructor() {
    return _getAllInstancesOf(FUNCTIONS_PROVIDER_NAME);
  }
}
const functionInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe(/*#__PURE__*/concatMap(() => from(_getAllInstancesOf(FUNCTIONS_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_FUNCTIONS_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.functions-instances');
function defaultFunctionsInstanceFactory(provided, defaultApp) {
  const defaultAuth = _getDefaultInstanceOf(FUNCTIONS_PROVIDER_NAME, provided, defaultApp);
  return defaultAuth && new Functions(defaultAuth);
}
function functionsInstanceFactory(fn) {
  return (zone, injector) => {
    const functions = zone.runOutsideAngular(() => fn(injector));
    return new Functions(functions);
  };
}
const FUNCTIONS_INSTANCES_PROVIDER = {
  provide: FunctionsInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_FUNCTIONS_INSTANCES]]
};
const DEFAULT_FUNCTIONS_INSTANCE_PROVIDER = {
  provide: Functions,
  useFactory: defaultFunctionsInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_FUNCTIONS_INSTANCES], FirebaseApp]
};
let FunctionsModule = /*#__PURE__*/(() => {
  class FunctionsModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'fn');
    }
    static ɵfac = function FunctionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FunctionsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FunctionsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_FUNCTIONS_INSTANCE_PROVIDER, FUNCTIONS_INSTANCES_PROVIDER]
    });
  }
  return FunctionsModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideFunctions(fn, ...deps) {
  registerVersion('angularfire', VERSION.full, 'fn');
  return makeEnvironmentProviders([DEFAULT_FUNCTIONS_INSTANCE_PROVIDER, FUNCTIONS_INSTANCES_PROVIDER, {
    provide: PROVIDED_FUNCTIONS_INSTANCES,
    useFactory: functionsInstanceFactory(fn),
    multi: true,
    deps: [NgZone, Injector, _AngularFireSchedulers, FirebaseApps,
    // Defensively load Auth first, if provided
    [new Optional(), AuthInstances], [new Optional(), AppCheckInstances], ...deps]
  }]);
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const httpsCallableData = /*#__PURE__*/_zoneWrap(httpsCallable$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const connectFunctionsEmulator = /*#__PURE__*/_zoneWrap(connectFunctionsEmulator$1, true);
const getFunctions = /*#__PURE__*/_zoneWrap(getFunctions$1, true);
const httpsCallable = /*#__PURE__*/_zoneWrap(httpsCallable$2, true);
const httpsCallableFromURL = /*#__PURE__*/_zoneWrap(httpsCallableFromURL$1, true);

/**
 * Generated bundle index. Do not edit.
 */

export { Functions, FunctionsInstances, FunctionsModule, connectFunctionsEmulator, functionInstance$, getFunctions, httpsCallable, httpsCallableData, httpsCallableFromURL, provideFunctions };
